(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    

  const isHomepage = window.location.pathname === "/" || window.location.pathname === "/index";
  const megaMenus = document.querySelectorAll('.mega-menu');
  const mainContent = document.getElementById('MainContent');
  class StickyHeader extends HTMLElement {
      constructor() {
          super();
      }
  
      connectedCallback() {
          this.header = document.querySelector('.section-header');
          this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
          this.headerBounds = {};
  
          this.setHeaderHeight();
  
          window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
  
          if (this.headerIsAlwaysSticky) {
              this.header.classList.add('shopify-section-header-sticky');
          };
  
          this.currentScrollTop = 0;
          this.preventReveal = false;
          this.predictiveSearch = this.querySelector('predictive-search');
  
          this.onScrollHandler = this.onScroll.bind(this);
          this.hideHeaderOnScrollUp = () => this.preventReveal = true;
  
          this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.addEventListener('scroll', this.onScrollHandler, false);
  
          this.createObserver();
          this.addMegaMenuListeners(); // Add listeners for mega menu open/close
      }
  
      setHeaderHeight() {
          document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
      }
  
      disconnectedCallback() {
          this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.removeEventListener('scroll', this.onScrollHandler);
      }
  
      createObserver() {
          let observer = new IntersectionObserver((entries, observer) => {
              this.headerBounds = entries[0].intersectionRect;
              observer.disconnect();
          });
  
          observer.observe(this.header);
      }
  
      addMegaMenuListeners() {
          megaMenus.forEach(megaMenu => {
              megaMenu.addEventListener('toggle', () => {
                  this.updateHeaderClasses();
              });
          });
      }
  
      updateHeaderClasses() {
          const headerDiv = this.header;
          let isMegaMenuOpen = false;
  
          megaMenus.forEach(megaMenu => {
              if (megaMenu.hasAttribute("open")) {
                  isMegaMenuOpen = true;
              }
          });
  
          if (isMegaMenuOpen && window.scrollY !== 0) {
        headerDiv.classList.add('scrolled-past-header', 'headerDiv');
        headerDiv.classList.remove('headerFullExpanded'); 
        document.body.classList.add("no-scroll");
    } else if (isMegaMenuOpen && window.scrollY === 0) {
        headerDiv.classList.add('headerFullExpanded');
        document.body.classList.add("no-scroll");
        headerDiv.classList.remove('scrolled-past-header', 'headerDiv');
    }  else if (!isHomepage && this.currentScrollTop > this.headerBounds.bottom) {
        headerDiv.classList.add('scrolled-past-header', 'headerDiv', 'headerFullExpanded');
        document.body.classList.remove("no-scroll");
    } else if (!isHomepage && this.currentScrollTop <= this.headerBounds.bottom){
        headerDiv.classList.remove('scrolled-past-header', 'headerDiv', 'headerFullExpanded');
    } else {
        headerDiv.classList.remove('headerFullExpanded'); 
        document.body.classList.remove("no-scroll");
    }
      }
  
      onScroll() {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  
          if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
  
          if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
              this.header.classList.add('scrolled-past-header');
              if (this.preventHide) return;
              requestAnimationFrame(this.hide.bind(this));
          } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
              this.header.classList.add('scrolled-past-header');
              if (!this.preventReveal) {
                  requestAnimationFrame(this.reveal.bind(this));
              } else {
                  window.clearTimeout(this.isScrolling);
  
                  this.isScrolling = setTimeout(() => {
                      this.preventReveal = false;
                  }, 66);
  
                  requestAnimationFrame(this.hide.bind(this));
              }
          } else if (scrollTop <= this.headerBounds.top) {
              this.header.classList.remove('scrolled-past-header');
              requestAnimationFrame(this.reset.bind(this));
          }
  
          this.currentScrollTop = scrollTop;
          this.updateHeaderClasses(); // Update classes on scroll too
      }
  
      hide() {
          if (this.headerIsAlwaysSticky) return;
          this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
          this.closeMenuDisclosure();
          this.closeSearchModal();
      }
  
      reveal() {
          if (this.headerIsAlwaysSticky) return;
          this.header.classList.add('shopify-section-header-sticky', 'animate');
          this.header.classList.remove('shopify-section-header-hidden');
      }
  
      reset() {
          if (this.headerIsAlwaysSticky) return;
          this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      }
  
      closeMenuDisclosure() {
          this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
          this.disclosures.forEach(disclosure => disclosure.close());
      }
  
      closeSearchModal() {
          this.searchModal = this.searchModal || this.header.querySelector('details-modal');
          this.searchModal.close(false);
      }
  }
  
  customElements.define('sticky-header', StickyHeader);
  
  document.addEventListener("DOMContentLoaded", function () {
      const headerWrapper = document.querySelector('.header-wrapper');
      const dropdowns = document.querySelectorAll('details.menu-toggle-selector');
  
      headerWrapper.addEventListener('focusin', function () {
          headerWrapper.classList.add('menu-open-active');
      });
      headerWrapper.addEventListener('focusout', function () {
          headerWrapper.classList.remove('menu-open-active');
      });
  });
  
  const headerDiv = document.querySelector('.section-header');
  console.log(megaMenus);
  
  if (!isHomepage) {
      headerDiv.classList.add('scrolled-past-header');
      headerDiv.classList.add('headerDiv');
  }
  
  } catch(e) { console.error(e); }
})();
})();
